<template>
  <div>
    <div
      v-for="(period, index) in value"
      :key="index"
      style="margin-bottom:5px;"
    >
      <div
        class="date-range-selector cf"
        :class="{
          multiple: value.length > 1,
          'del-alert': show_delete_alert(index)
        }"
      >
        <div class="col50">
          <div>
            <div
              class="label txt-help"
              :class="{
                'has-error':
                  $v &&
                  $v.$each &&
                  $v.$each.$iter[index].from_time.$dirty &&
                  $v.$each.$iter[index].from_time.$error
              }"
            >
              {{ T__("FROM") }}
            </div>
            <!-- <input
            type="text"
            placeholder="hh:mm am"
            v-model="period.from_time"
          /> -->
            <TimePicker v-model="period.from_time" />
          </div>
        </div>
        <div
          class="icon-delete"
          v-if="value.length > 1"
          @click="
            value.splice(index, 1);
            set_mouseover(index, false);
          "
          @mouseover="set_mouseover(index, true)"
          @mouseleave="set_mouseover(index, false)"
        ></div>
        <div class="col50">
          <div>
            <div
              class="label txt-help"
              :class="{
                'has-error':
                  $v &&
                  $v.$each &&
                  $v.$each.$iter[index].to_time.$dirty &&
                  $v.$each.$iter[index].to_time.$error
              }"
            >
              {{ T__("TO") }}
            </div>
            <!-- <input type="text" placeholder="hh:mm am" v-model="period.to_time" /> -->
            <TimePicker v-model="period.to_time" />
          </div>
        </div>
      </div>
      <form-row
        v-if="$v && $v.$each && $v.$each.$iter[index]"
        :validator="$v.$each.$iter[index].from_time"
      >
      </form-row>
      <form-row
        v-if="$v && $v.$each && $v.$each.$iter[index]"
        :validator="$v.$each.$iter[index].to_time"
      >
      </form-row>
    </div>

    <a @click="add_new_range" v-if="can_show_add_period">{{
      T__("+ Add another period")
    }}</a>
  </div>
</template>

<script>
import TimePicker from "@/components/form_elements/TimePicker.vue";

export default {
  name: "TimeRange1ToN",
  components: {
    TimePicker
  },
  props: {
    $v: {},
    value: {
      type: Array,
      required: true
    },
    hide_add_period_on_no_periods: {
      default: "0"
    },
    disable_multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      delete_alert_index: null
    };
  },

  computed: {
    hide_add_period_on_no_periods_check() {
      return (
        this.hide_add_period_on_no_periods == "1" && this.value.length == 0
      );
    },
    can_show_add_period() {
      return (
        this.disable_multiple === false &&
        !this.hide_add_period_on_no_periods_check
      );
    }
  },
  methods: {
    add_new_range: function() {
      let new_range = { from_time: "", to_time: "" };
      this.value.push(new_range);
    },
    show_delete_alert(index) {
      return this.delete_alert_index === index;
    },
    set_mouseover(index, is_hover) {
      if (is_hover) {
        this.delete_alert_index = index;
      } else {
        this.delete_alert_index = null;
      }
    }
  }
};
</script>

<style>
.vue__time-picker .time-picker-overlay {
  z-index: 4000;
}

.vue__time-picker .dropdown {
  z-index: 5000;
}
.time-range-selector .vue__time-picker input[type="text"]:hover {
  background-color: #e4e9f5 !important;
  border-radius: 3px !important;
}
</style>
